<template>
<div>
  <v-list-item v-if="$vuetify.breakpoint.mdAndUp" class="sidebar__element" :to="to" >
    <v-list-item-content  class="d-flex flex-column align-center justify-center">
      <v-avatar class="mx-auto">        
        <v-icon v-if="icon_type == 'icon'" v-once color="#F4F4F4">
          {{ icon_src }}
        </v-icon>
        <img v-else class="img-sidebar-navigation"  :src="icon_src" width="28px" height="28px"/>
      </v-avatar>
      <img          
          class="menu-item-label-new" 
          v-if="new_label"
          width="32px"
          height="10px"
          src="/navigation/new_label.svg"
        >
      <p class="sidebar__element__title mt-1 mb-0">
        <slot name="text" />
      </p>
    </v-list-item-content>
    </v-list-item>
    <v-list-item class="sidebar__element py-1 px-3" v-else :to="to">  
      <v-list-item-avatar>
        <v-avatar color="primary">
          <v-icon v-if="icon_type == 'icon'" v-once color="primary">
            {{ icon_src }}
          </v-icon>
          <v-img class="img-sidebar-navigation" v-else :src="icon_src" width="28px" height="28px"></v-img>          
        </v-avatar>
      </v-list-item-avatar>
      <v-list-item-content class="primary--text" >
        <slot name="text" />
      </v-list-item-content>
  </v-list-item>
</div>
</template>

<script>
export default {
  name: 'SidebarElement',

  props: {
    to: {
      type: [String, Object],
      default: null,
    },
    new_label: {
      type: Boolean,
      default: false
    },
    icon_type: {
      type: String,
      default: "icon"
    },
    icon_src: {
      type: String,
      default:""
    }
  }
}
</script>

<style>
.sidebar__element__title {
  max-width: 66px;
  overflow-wrap: break-word;
  word-break: normal;
  overflow: auto;
  white-space: initial;
  text-align: center;
  font-size: 0.72rem;
  font-weight: 400;
  line-height: 1rem;
  color: #F4F4F4;
}

.sidebar__element.v-list-item:hover::before,
.sidebar__element.v-list-item--active:hover::before {
  opacity: 0.04
}

.sidebar__element.v-list-item--active::before {
  opacity: 0
}

.sidebar__element.v-list-item .menu-item-label-new {
  position:absolute;
  top:8px;
  right:10px;
}

.sidebar__element.v-list-item .v-avatar {
  width: 40px !important;
  min-width: 40px !important;
  height: 40px !important;
  min-height: 40px !important;
  border-radius: 10px;
  background: rgb(255, 255, 255, 0.1) !important;  
}
.sidebar__element.v-list-item .v-avatar:hover {
  background: rgb(255, 255, 255, 1) !important; 
}

.sidebar__element.v-list-item--active .v-avatar {
  background: rgb(255, 255, 255, 0.4) !important;
}

@media screen and (max-width: 960px) {  
  .sidebar__element.v-list-item .v-avatar {
    background: rgb(74, 51, 126, 0.4) !important;  
  }
  .sidebar__element.v-list-item .v-avatar .v-icon {
    color:#F4F4F4 !important;
  }  
}

.sidebar__element.v-list-item .img-sidebar-navigation {
  width: 28px;
  height: 28px;  
  max-width: 28px;
}
.sidebar__element.v-list-item .v-avatar:hover .img-sidebar-navigation {
  filter: invert(129%) sepia(63%) saturate(4864%) hue-rotate(206deg) brightness(79%) contrast(87%);    
}

.sidebar__element.v-list-item .v-avatar:hover .v-icon {
  color: #112035 !important;
}
</style>